import { computed, inject, provide, ref, Ref } from "vue"
import { Group } from "suus-api"
import { groupApi } from "store/api"

export function provideGroupContext() {
  const groupContext = new GroupContext()
  provide("GroupContext", groupContext)
  return groupContext
}

export function useGroupContext(): GroupContext {
  const groupContext = inject<GroupContext>("GroupContext")
  if (!groupContext) {
    throw new Error("No GroupContext provided")
  }
  return groupContext
}

export default class GroupContext {
  private readonly _currentGroup: Ref<Group | null> = ref(null)
  public currentGroup = computed(() => this._currentGroup.value)
  public isGroupAvailable: Readonly<Ref<boolean>> = computed(
    () => !!this._currentGroup.value?.id
  )

  public async getGroup(groupId: string) {
    try {
      const { data } = await groupApi.getGroup(groupId)
      console.log(data)
      console.log(this._currentGroup)
      this._currentGroup.value = data
    } catch (err) {
      console.error(err)
    }
  }
}
